/**
 * Alinhado à validação do backend: título do relatório na base (RelatoriosDinamicos.TituloRelatorio).
 */
export function isRelatorioControleEmailsTitulo(tituloRelatorio) {
  if (!tituloRelatorio || typeof tituloRelatorio !== 'string') return false;
  const t = tituloRelatorio.toLowerCase();
  if (!t.includes('controle')) return false;
  return t.includes('e-mail') || t.includes('e-mails') || t.includes('email');
}
